import React, { useRef, useState, useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

export default function Consequence({ consequence, updatePage, updateConsequencesFilter, closePatternDetails, extraStyle = '' }) {
    const consequenceRef = useRef(); // Reference to the div
    const [popoverWidth, setPopoverWidth] = useState(200); // State to store the popover width

    // Effect to set the popover width after the component renders
    useEffect(() => {
        if (consequenceRef.current) {
            const width = consequenceRef.current.getBoundingClientRect().width;
            setPopoverWidth(width + 2); // Update popover width dynamically
        }
    }, []); // Run when the ref changes

    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement='bottom'
            overlay={
                <Popover
                    id='consequence-popover'
                    style={{
                        maxWidth: '100%',
                        width: popoverWidth,
                        minWidth: 200
                    }}
                >
                    <Popover.Title>
                        {consequence.consequence_title}
                    </Popover.Title>
                    <Popover.Content>
                        {consequence.consequence_description}
                    </Popover.Content>
                </Popover>
            }
        >
            <div
                key={"pattern-consequence-" + consequence.consequence_id}
                id={"pattern-consequence-" + consequence.consequence_id}
                className={`consequence clickable ${extraStyle} truncate`}
                onClick={() => {
                    updateConsequencesFilter && updateConsequencesFilter([consequence.consequence_id]);
                    updatePage && updatePage(0);
                    closePatternDetails && closePatternDetails(null);
                }}
                ref={consequenceRef} // Assign the ref here
            >
                <b>{consequence.consequence_title}</b> - {consequence.consequence_description}
            </div>
        </OverlayTrigger>
    );
}
